import React, { useEffect } from 'react';
import { LoomEmbed } from '../components/cdv/LoomEmbed';
import { CdvCtaButton } from '../components/cdv/CdvCtaButton';
import { WhatsAppFloatButton } from '../components/cdv/WhatsAppFloatButton';
import { CdvHeader } from '../components/cdv/CdvHeader';
import { academyTestimonials } from '../data/academiaTestimonios';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { trackPage } from '../utils/analytics';
export function AcademiaTestimonios() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackPage('/academia-testimonios');
  }, []);
  const videos = academyTestimonials.flatMap(person => person.loomIds.map((loomId, i) => ({
    loomId,
    name: person.name,
    part: person.loomIds.length > 1 ? `${i + 1} de ${person.loomIds.length}` : ''
  })));
  return <div className="min-h-screen w-full bg-black font-sans text-white" data-id="element-363" data-mp="1zb8qnupo2vok">
      <CdvHeader secondaryLabel="Más información" secondaryTo="/academia-cdv" trackingPrefix="testimonios" data-id="element-364" data-mp="249jyy10bcy4o" />
      <main data-id="element-365" data-mp="3m72daytjczci">
        <section className="px-5 pt-12 pb-10 md:pt-16 md:pb-14" data-id="element-366" data-mp="3i7l5hyqmzq46">
          <div className="max-w-3xl mx-auto text-center" data-id="element-367" data-mp="3i60dafrsoj9h">
            <h1 className="font-sans text-3xl md:text-5xl font-extrabold uppercase leading-[1.1]" data-id="element-368" data-mp="3d7ysnqeq0bvw">
              Testimonios de la Academia
            </h1>
            <p className="mt-4 text-base md:text-lg text-white/70 leading-relaxed" data-id="element-369" data-mp="38bi6v2uzu9lz">
              No desde la teoría, desde la práctica. Escucha directamente a los
              miembros que ya están aplicando el sistema.
            </p>
          </div>
        </section>

        <section aria-label="Videos de testimonios" className="px-5 pb-16 md:pb-24" data-id="element-370" data-mp="nkje49ac6j">
          <ul className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10" data-id="element-371" data-mp="3r7zt54r2phau">
            {videos.map(video => <li key={video.loomId} className="flex flex-col" data-id="element-372" data-mp="nrj6vvpy0f6e">
                <LoomEmbed loomId={video.loomId} title={`Testimonio de ${video.name}${video.part ? `, video ${video.part}` : ''}`} data-id="element-373" data-mp="nq886abctxm5" />
                <p className="mt-3 flex items-baseline justify-between gap-3" data-id="element-374" data-mp="2m0grho8l297v">
                  <span className="font-sans text-lg md:text-xl font-bold text-white" data-id="element-375" data-mp="288ipdxdahdl7">
                    {video.name}
                  </span>
                  {video.part && <span className="text-sm text-white/50" data-id="element-376" data-mp="1yaw5sxl1oxuw">
                      Video {video.part}
                    </span>}
                </p>
              </li>)}
          </ul>
        </section>

        <section className="px-5 py-16 md:py-20 bg-[#0B0B0B] border-t border-white/10" data-id="element-377" data-mp="1pc0ytja6fjqj">
          <div className="max-w-2xl mx-auto text-center" data-id="element-378" data-mp="1uau2yl3kpye1">
            <h2 className="font-sans text-2xl md:text-4xl font-bold uppercase leading-tight" data-id="element-379" data-mp="3joqt424giuyg">
              Tú puedes ser el siguiente testimonio
            </h2>
            <p className="mt-4 text-lg text-white/70" data-id="element-380" data-mp="3on25aji85hju">
              Únete a la Academia de Bienes Raíces y empieza a construir
              múltiples fuentes de ingreso.
            </p>
            <div className="mt-8" data-id="element-381" data-mp="3ttyx5l97f7ii">
              <CdvCtaButton trackingId="testimonios_cta_click" data-id="element-382" data-mp="3tquj7w5xsxen" />
            </div>
          </div>
        </section>
      </main>

      <WhatsAppFloatButton data-id="element-383" data-mp="6nfy1iz31enk" />

      <footer className="w-full border-t border-white/10" data-id="element-384" data-mp="6n697yprxdjg">
        <div className="max-w-5xl mx-auto px-4 py-8 md:py-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-center md:text-left" data-id="element-385" data-mp="lclx96xx74vg">
          <div data-id="element-386" data-mp="gczjmwe6jmm4">
            <p className="text-lg md:text-2xl font-bold" data-id="element-387" data-mp="gdj3iine4l2s">Bienes Raíces Academy</p>
            <p className="text-sm md:text-lg text-white/80" data-id="element-388" data-mp="uc8wbm36fylc">Por Susana Sánchez G</p>
          </div>
          <div className="text-center leading-tight" data-id="element-389" data-mp="qd9uwbgnmjyn">
            <p className="text-base md:text-xl font-bold tracking-[0.15em] text-white" data-id="element-390" data-mp="2w4nd2htzix06">
              ACADEMIA
            </p>
            <p className="text-lg md:text-2xl font-extrabold tracking-wide text-gold-metallic" data-id="element-391" data-mp="2s4dalf5eioq2">
              BIENES RAÍCES
            </p>
          </div>
          <p className="text-xs text-white/60 md:text-right" data-id="element-392" data-mp="2tmttsv2ijv0d">
            Todos los Derechos Reservados
            <br data-id="element-393" data-mp="32l5op9aexeym" />
            2026
          </p>
        </div>
      </footer>
    </div>;
}